import React from "react";
import Badge from "@src/common/components/Badge";
import { Label } from "@api/graphql/generated/generated-types";

interface LabelBadgeProps {
  label: Label;
  onClick?: () => void;
  className?: string;
  size?: "xs" | "sm";
}

export function LabelBadge({
  label,
  onClick,
  className,
  size,
}: LabelBadgeProps) {
  // Handle null/undefined color by providing a fallback
  const badgeColor = label.color || "gray";

  return (
    <Badge
      key={label.id}
      color={badgeColor}
      onClick={onClick}
      size={size}
      className={`${onClick ? "cursor-pointer hover:opacity-80" : ""} ${
        className || ""
      }`}
    >
      {label.name}
    </Badge>
  );
}
